import { Component, OnInit, ViewChild } from '@angular/core';
import { map, tap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { CostService } from 'src/app/shared/services/cost.service';
import { combineLatest } from 'rxjs';
import { CostStatuses, Cost } from 'src/app/shared/models/cost.model';
import { TableDataSource } from 'src/app/shared/components/table/table-data-source';
import { MatSort } from '@angular/material/sort';
import { tableSortFn } from 'src/app/shared/utils/sort.util';

@Component({
  selector: 'app-employee-costs',
  templateUrl: './employee-costs.component.html',
})
export class EmployeeCostsComponent implements OnInit {
  costStatusTab: string;
  costsByTab$;
  costs$;
  costsCount$;
  id: number;
  dataSource = new TableDataSource<Cost>();

  @ViewChild(MatSort, { static: false }) set sort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  constructor(
    private route: ActivatedRoute,
    private costService: CostService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.id = Number(this.activatedRoute.snapshot.paramMap.get('id'));
    this.costs$ = this.costService.fetchEmployeeCosts(this.id);



    this.costsCount$ = this.costs$.pipe(
      map((costs: Cost[]) => costs.reduce((totals, cost) => ({
        ...totals, [cost.status.name]: (totals[cost.status.name] || 0) + 1
      }), {})
      ),
      map(tabs => {
        Object.values(CostStatuses).map(status => {
          tabs[status] = tabs[status] || 0;
        });
        tabs['progress'] =
          tabs[CostStatuses.New]
          + tabs[CostStatuses.InApproval]
          + tabs[CostStatuses.ReadyToReturn]
          + tabs[CostStatuses.Returned]
          + tabs[CostStatuses.Approved]
          + tabs[CostStatuses.Printed];
        return tabs;
      }),
    );

    this.costsByTab$ = combineLatest([
      this.route.paramMap,
      this.costs$
    ])
      .pipe(
        map(([paramsAsMap, costs]) => (<Cost[]>costs).filter(cost => {
          const costStatusTab = paramsAsMap.get('costStatusTab');
          let hasStatus = false;
          costStatusTab === 'progress'
            ? hasStatus = cost.status.name !== CostStatuses.Settled
            && cost.status.name !== CostStatuses.Rejected
            && cost.status.name !== CostStatuses.Canceled
            : hasStatus = cost.status.name === costStatusTab;
          return hasStatus;
        })),
        map((costs: Cost[]) => {
          this.dataSource.data = costs;
          this.dataSource.sortingDataAccessor = tableSortFn;
          return costs;
        })
      );
  }

}
